var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sort-by-small text-left text-xl-right  ml-auto" },
    [
      _c("div", { staticClass: "no-gutters d-flex pb-2" }, [
        _c(
          "span",
          {
            staticClass:
              "pr-2 text-muted text-uppercase text-size-small font-16 pt-1 text-nowrap"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$resourceString["common.accounts.Title.Sort"]) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedOption,
                expression: "selectedOption"
              }
            ],
            staticClass: "font-16 pl-2 border-0 custom-dropdown",
            attrs: { id: "dropdown" },
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedOption = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.handleDropdownChange
              ]
            }
          },
          _vm._l(_vm.options, function(option, index) {
            return _c(
              "option",
              { key: index, domProps: { value: option.value } },
              [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }